import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "mt-16 mb-8" }
const _hoisted_3 = { class: "flex flex-wrap items-center justify-between space-y-2 md:space-y-0 md:flex-nowrap" }
const _hoisted_4 = { class: "flex flex-wrap mt-6 space-y-2 md:space-y-0 md:space-x-2 md:flex-nowrap" }
const _hoisted_5 = { class: "flex w-full md:w-1/4" }
const _hoisted_6 = {
  class: "capitalize",
  value: "all",
  selected: ""
}
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "flex w-full md:w-1/4" }
const _hoisted_9 = {
  class: "capitalize",
  value: "all",
  selected: ""
}
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "flex w-full md:w-1/4" }
const _hoisted_12 = {
  class: "capitalize",
  value: "all",
  selected: ""
}
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "flex w-full md:w-1/4" }
const _hoisted_15 = {
  class: "capitalize",
  value: "all",
  selected: ""
}
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "mt-4" }
const _hoisted_18 = { class: "mt-5" }
const _hoisted_19 = { class: "flex flex-wrap gap-4" }

import { ref, computed } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import RoleGuard from "@/components/RoleGuard.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import RouterButton from "@/components/RouterButton.vue";
import PaginationBar from "@/components/PaginationBar.vue";
import ResourceCard from "@/components/resources/ResourceCard.vue";

import api from "@/api/api";
import { useGlobalStore, useUserStore } from "@/store";
import { PaginationMeta, Resource } from "@/types";
import { userHasRole } from "@/utils/roles";
import { useFilters } from "@/composables/filters";
import { slugify } from "@/utils/slugify";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcesList',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const { user } = storeToRefs(useUserStore());
const { course_roles } = storeToRefs(useGlobalStore());
const { filters, getFiltersFromQuery, filter, setFilterNoRefresh } = useFilters(route);

const languages = ref([] as string[]);
const resources = ref([] as Resource[]);
const tags = ref([] as string[]);
const meta = ref({} as PaginationMeta);

const courseRolesSorted = course_roles.value.sort((a, b) => a.display_name.localeCompare(b.display_name));

const types = [
  {
    value: "activity",
  },
  {
    value: "club-promotion",
  },
  {
    value: "facilitation-aid",
  },
  {
    value: "supporting-asset",
  },
  {
    value: "training-resources",
  },
];

const filteredTypes = computed(() => {
  if (userHasRole(user.value.roles, ["parent", "brick-club-family"])) {
    return types.filter(t => t.value !== "training-resources");
  }

  return types;
});

async function search() {
  const response = await api.resources.listResources(filters.value);
  resources.value = response.data.resources;
  meta.value = response.meta;
}

async function getTags() {
  const response = await api.resources.listTags();
  tags.value = response.data.tags;
}

languages.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.misc.listLanguages())),
  __temp = await __temp,
  __restore(),
  __temp
)).languages.sort((a, b) => a.localeCompare(b));

getFiltersFromQuery();

if (!filters.value.type) {
  (
  ([__temp,__restore] = _withAsyncContext(() => setFilterNoRefresh("type", "all"))),
  await __temp,
  __restore()
);
}

if (!filters.value.language) {
  (
  ([__temp,__restore] = _withAsyncContext(() => setFilterNoRefresh("language", "all"))),
  await __temp,
  __restore()
);
}

if (!filters.value.tag) {
  (
  ([__temp,__restore] = _withAsyncContext(() => setFilterNoRefresh("tag", "all"))),
  await __temp,
  __restore()
);
}

if (!filters.value.role) {
  (
  ([__temp,__restore] = _withAsyncContext(() => setFilterNoRefresh("role", "all"))),
  await __temp,
  __restore()
);
}

;(
  ([__temp,__restore] = _withAsyncContext(() => search())),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => getTags())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('resources')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(RoleGuard, { roles: ['admin'] }, {
          default: _withCtx(() => [
            _createVNode(RouterButton, {
              type: "secondary",
              loading: false,
              disabled: false,
              to: { path: '/dashboard/resources/new' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("upload-resource")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(filter) && _unref(filter)(...args))),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filters).type) = $event)),
            id: "type",
            name: "type",
            class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
          }, [
            _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t("all-types")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredTypes), (t, index) => {
              return (_openBlock(), _createElementBlock("option", {
                class: "capitalize",
                key: index,
                value: t.value
              }, _toDisplayString(_ctx.$t(t.value)), 9, _hoisted_7))
            }), 128))
          ], 544), [
            [_vModelSelect, _unref(filters).type]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("select", {
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(filter) && _unref(filter)(...args))),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filters).language) = $event)),
            id: "language",
            name: "language",
            class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
          }, [
            _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t("all-languages")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
              return (_openBlock(), _createElementBlock("option", {
                class: "capitalize",
                value: language,
                key: language
              }, _toDisplayString(_ctx.$t(_unref(slugify)(language))), 9, _hoisted_10))
            }), 128))
          ], 544), [
            [_vModelSelect, _unref(filters).language]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("select", {
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(filter) && _unref(filter)(...args))),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(filters).tag) = $event)),
            id: "tag",
            name: "tag",
            class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
          }, [
            _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t("all-tags")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (t, index) => {
              return (_openBlock(), _createElementBlock("option", {
                class: "capitalize",
                key: index,
                value: t
              }, _toDisplayString(t), 9, _hoisted_13))
            }), 128))
          ], 544), [
            [_vModelSelect, _unref(filters).tag]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(RoleGuard, {
            roles: ['admin'],
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("select", {
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(filter) && _unref(filter)(...args))),
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(filters).role) = $event)),
                id: "roles",
                name: "roles",
                class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
              }, [
                _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t("all-roles")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(courseRolesSorted), (role) => {
                  return (_openBlock(), _createElementBlock("option", {
                    class: "capitalize",
                    value: role.name,
                    key: role.id
                  }, _toDisplayString(_ctx.$t(role.name)), 9, _hoisted_16))
                }), 128))
              ], 544), [
                [_vModelSelect, _unref(filters).role]
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("resources-pagination", [meta.value.pagination.total_entries])), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resources.value, (resource) => {
            return (_openBlock(), _createBlock(ResourceCard, {
              key: resource.id,
              resource: resource
            }, null, 8, ["resource"]))
          }), 128))
        ])
      ]),
      _createVNode(PaginationBar, { meta: meta.value }, null, 8, ["meta"])
    ])
  ], 64))
}
}

})